import React, { useState, useEffect } from "react";
import { Form, Row, InputGroup } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import {
  CButton,
  CCol,
  CFormInput,
  CFormLabel,
  CFormFeedback,
} from "@coreui/react";
import { getMasterData } from "../../../redux/slices/CustomerSlice";
import { useDispatch } from "react-redux";
import FormWrapper from "../../../pagecomponents/Common/FormWrapper";
import { getData } from "../../../redux/slices/MasterSupplierSlice";
import { addData, editVchData } from "../../../redux/slices/VoucherSlice";
import { checkEmpty, toastMessage } from "../../../helpers/utility.js";

const INIT_FORM_DATA = {
  voucher_Type: "Payment",
  voucher_Date: format(new Date(), "yyyy-MM-dd"),
  voucher_No: "",
  voucher_Payment_Mode: "",
  voucher_Note: "",
  invoice_Id: "",
  client_Id: 1,
  voucher_Id: 0,
  staff_Id: 1,
  voucher_payment: [
    {
      voucher_payment_Id: 0,
      voucher_payment_Data: "", // supplier id
      voucher_payment_Name: "", // supplier name
      voucher_payment_Type: "Supplier",
      voucher_payment_Amount: 0,
      type: "",
    },
  ],
};

const PaymentVchAddEdit = ({ invisible, loadData, mode, editData }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(INIT_FORM_DATA);
  const [masterData, setMasterData] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);

  useEffect(() => {
    fetchMasterData();
    document
      .querySelector("input[name='voucher_payment_Name']")
      .setAttribute("autocomplete", "off");
  }, [mode, editData, dispatch]); // Dependency array to prevent unnecessary re-renders

  const fetchMasterData = async () => {
    let PARAMS = {};
    const { payload } = await dispatch(getMasterData({ inputData: PARAMS }));
    if (payload?.status === "error") {
      console.error("Error fetching data:", payload.msg);
    } else {
      console.log(payload.payment_mode);
      setMasterData(payload);
    }
  };

  useEffect(() => {
    if (mode && editData) {
      //   console.log("Incoming data:", editData);

      setFormData((prev) => ({
        ...prev,
        voucher_Type: "Payment",
        voucher_Date: format(new Date(editData.voucher_Date), "yyyy-MM-dd"),
        voucher_No: editData.voucher_No,
        voucher_Payment_Mode: editData.voucher_Payment_Mode,
        reference_no: editData.reference_no,
        voucher_Note: editData.voucher_Note,
        invoice_Id: editData.invoice_Id,
        // reference_no: editData.reference_no,
        client_Id: 1,
        voucher_Id: editData.voucher_Id,
        staff_Id: 1,
        voucher_payment: [
          {
            voucher_payment_Id: editData.voucher_payment[0].voucher_payment_Id,
            voucher_payment_Data:
              editData.voucher_payment[0].voucher_payment_Data,
            voucher_payment_Name:
              editData.voucher_payment[0].voucher_payment_Name,
            voucher_payment_Type:
              editData.voucher_payment[0].voucher_payment_Type,
            voucher_payment_Amount:
              editData.voucher_payment[0].voucher_payment_Amount,
            type: "",
          },
        ],
      }));
    }
  }, [mode, editData]);

  //   const handleInputChange = (e) => {
  //     const { name, value } = e.target;
  //     if (name === "voucher_Date") {
  //       setFormData({
  //         ...formData,
  //         [name]: format(new Date(value), "yyyy-MM-dd"), // Format the date
  //       });
  //     } else {
  //       setFormData({
  //         ...formData,
  //         [name]: value,
  //       });
  //     }
  //   };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    const updatedFormData = { ...formData }; // Start with old form data

    if (name === "voucher_Payment_Mode") {
      const selectedOption = masterData.payment_mode?.find(
        (item) => item.payment_mode_master_Id == value
      );

      if (selectedOption) {
        updatedFormData[name] = value;
        updatedFormData.payment_mode_Name = selectedOption.payment_mode_Name;
        updatedFormData.payment_mode_Code = selectedOption.payment_mode_Code;
      }
    } else if (name === "voucher_Date") {
      updatedFormData[name] = format(new Date(value), "yyyy-MM-dd");
    } else {
      updatedFormData[name] = value;
    }

    setFormData(updatedFormData); // Set state once
  };

  const handleSave = async () => {
    // console.log("Form Submit Paylod: ",formData);
    // return;
    if (checkEmpty(formData.voucher_Payment_Mode)) {
      toastMessage("error", "Payment mode is required.");
      return;
    } else if (formData.voucher_payment[0].voucher_payment_Amount === 0) {
      toastMessage("error", "Amount can't be 0");
      return;
    } else if (!checkEmpty(formData.voucher_payment[0].voucher_payment_Data)) {
      setIsSaveDisabled(true);
      let api = mode ? editVchData : addData;
      const { payload } = await dispatch(api({ inputData: formData }));
      if (payload?.status === "error") {
        setIsSaveDisabled(false);
        toastMessage("error", payload.msg || "An error occurred while saving.");
      } else {
        setIsSaveDisabled(false);
        toastMessage(
          payload?.status || "success",
          payload?.msg || "Operation successful."
        );
        invisible();
        loadData();
      }
    } else {
      toastMessage("error", "Enter valid supplier");
    }
  };

  const handleAutoComplete = async (e) => {
    const { name, value } = e.target;

    // Update the value in formData state for the input field
    setFormData((prevState) => {
      const updatedVoucherPayment = [...prevState.voucher_payment];
      updatedVoucherPayment[0] = {
        ...updatedVoucherPayment[0],
        [name]: value,
      };
      return {
        ...prevState,
        voucher_payment: updatedVoucherPayment,
      };
    });

    if (value.trim() !== "") {
      try {
        let params = {
          skip: 0,
          take: 1000,
          searchStr: value,
          sorting: "asc",
          sorting_key: "created_at",
          filter: {},
        };
        const { payload } = await dispatch(getData({ inputData: params }));
        setSuggestions(payload.data);
      } catch (error) {
        setSuggestions([]);
      }
    } else {
      setSuggestions([]);
    }
  };

  const setSupplierData = (supplierData) => {
    setFormData((prevState) => ({
      ...prevState,
      voucher_payment: [
        {
          ...prevState.voucher_payment[0], // Preserve other properties in voucher_payment
          voucher_payment_Data: supplierData?.supplier_Id || "",
          voucher_payment_Name: supplierData?.supplier_Name || "",
          voucher_payment_Type: "Supplier",
          voucher_payment_Amount:
            prevState.voucher_payment[0]?.voucher_payment_Amount || 0,
          type: "",
        },
      ],
    }));
    setSuggestions([]); // Clear suggestions
  };

  const setVoucherAmount = (e) => {
    let { value } = e.target;

    if (value.length > 1 && value.startsWith("0")) {
      value = value.replace(/^0+/, "");
    }
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      // Allow only numbers and up to 2 decimal places
      setFormData((prevState) => ({
        ...prevState,
        voucher_payment: prevState.voucher_payment.map((payment, index) =>
          index === 0 // Update the first object in the array
            ? {
                ...payment,
                voucher_payment_Amount: value,
              }
            : payment
        ),
      }));
    }
  };

  return (
    <FormWrapper onSubmit={handleSave}>
      <Row className="row-xs mb-2">
        <CCol md={4}>
          <CFormLabel
            className="main-content-label tx-11 tx-medium tx-gray-600"
            htmlFor="voucher_Date"
          >
            Vch Date
          </CFormLabel>
          <InputGroup className="input-group reactdate-pic">
            <InputGroup.Text className="input-group-text">
              <i className="typcn typcn-calendar-outline tx-24 lh--9 op-6"></i>
            </InputGroup.Text>
            <DatePicker
              className="form-control"
              name="voucher_Date"
              id="voucher_Date"
              selected={
                formData.voucher_Date ? new Date(formData.voucher_Date) : null
              } // Convert to Date object
              onChange={(date) => {
                const event = {
                  target: {
                    name: "voucher_Date",
                    value: date,
                  },
                };
                handleInputChange(event); // Simulate an event for compatibility
              }}
              dateFormat="yyyy-MM-dd" // Match the desired format
              // isClearable // Optional: Allow clearing the date
            />
          </InputGroup>
          <CFormFeedback invalid>Enter Voucher Date</CFormFeedback>
        </CCol>
        {/* <CCol md={3}>
                    <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="voucher_No">Vch No</CFormLabel>
                    <CFormInput
                        type="text"
                        id="voucher_No"
                        name="voucher_No"
                        value={formData.voucher_No}
                        onChange={handleInputChange}
                        required
                    />
                    <CFormFeedback invalid>Enter Voucher No</CFormFeedback>
                </CCol> */}
        <CCol md={4}>
          <CFormLabel
            className="main-content-label tx-11 tx-medium tx-gray-600"
            htmlFor="voucher_Payment_Mode"
          >
            Paid By
          </CFormLabel>
          <Form.Select
            className="form-control"
            aria-label="Paid By"
            name="voucher_Payment_Mode"
            value={formData.voucher_Payment_Mode}
            onChange={handleInputChange}
          >
            <option value="">Choose...</option>
            {/* Map over the options array to generate the option elements dynamically */}
            {masterData.payment_mode?.map((option) => (
              <option
                key={option.payment_mode_master_Id}
                value={option.payment_mode_master_Id}
              >
                {option.payment_mode_Name}
              </option>
            ))}
          </Form.Select>
          <CFormFeedback invalid>Select Paid By</CFormFeedback>
        </CCol>
        <CCol md={4}>
          <CFormLabel
            className="main-content-label tx-11 tx-medium tx-gray-600"
            htmlFor="reference_no"
          >
            Reference No <span style={{ color: "red" }}>*</span>
          </CFormLabel>
          <CFormInput
            type="text"
            id="reference_no"
            name="reference_no"
            value={formData.reference_no}
            onChange={handleInputChange}
            required
            invalid={!formData.reference_no} // if using CoreUI validation
          />
          <CFormFeedback invalid>Reference No is required</CFormFeedback>
        </CCol>
      </Row>
      <Row className="row-xs mb-2">
        <CCol md={8}>
          <CFormLabel
            className="main-content-label tx-11 tx-medium tx-gray-600"
            htmlFor="supplier_Name"
          >
            Select Supplier
          </CFormLabel>
          <div className="hsc-wrapper">
            <InputGroup className="input-group">
              <CFormInput
                type="text"
                id="voucher_payment_Name"
                name="voucher_payment_Name"
                value={formData.voucher_payment[0].voucher_payment_Name}
                onChange={handleAutoComplete}
                required
                autoComplete="false"
              />
              {/* <Button
                                variant=""
                                className="btn btn-primary br-ts-0 br-bs-0"
                                type="button"
                                // onClick={addCustomerModal}
                            >
                                <i className="fa fa-plus"></i>
                            </Button> */}
            </InputGroup>
            {suggestions && suggestions.length > 0 && (
              <div
                className="header-search-container"
                onMouseDown={(e) => e.preventDefault()}
                onPointerDown={(e) => e.preventDefault()}
              >
                <div className="hs">
                  {/* <Container fluid> */}
                  {/* <Row className="d-flex justify-content-between mt-3 align-items-stretch"> */}
                  {suggestions?.map((suggestion, index) => (
                    // <div>
                    <div
                      key={suggestion?.supplier_Id || index}
                      className="main-message-list header-search-element"
                      onPointerDown={(e) => {
                        e.preventDefault();
                        setSupplierData(suggestion);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <strong>{suggestion?.supplier_Name} </strong>
                      <span>{suggestion?.supplier_Email}</span>
                      <span>{suggestion?.supplier_Mobile}</span>
                    </div>
                    // </div>
                  ))}
                  {/* </Row> */}
                  {/* </Container> */}
                </div>
              </div>
            )}
          </div>
          <CFormFeedback invalid>Select or Add Supplier</CFormFeedback>
        </CCol>

        <CCol md={4}>
          <CFormLabel
            className="main-content-label tx-11 tx-medium tx-gray-600"
            htmlFor="voucher_payment_Amount"
          >
            Amount
          </CFormLabel>
          <CFormInput
            type="text"
            id="voucher_payment_Amount"
            name="voucher_payment_Amount"
            value={formData.voucher_payment[0].voucher_payment_Amount}
            onChange={setVoucherAmount}
            required
          />
          <CFormFeedback invalid>Enter Amount</CFormFeedback>
        </CCol>
      </Row>
      <Row className="row-xs mb-2">
        <CCol md={12}>
          <CFormLabel
            className="main-content-label tx-11 tx-medium tx-gray-600"
            htmlFor="voucher_Note"
          >
            Narration
          </CFormLabel>
          <CFormInput
            type="text"
            id="voucher_Note"
            name="voucher_Note"
            value={formData.voucher_Note}
            onChange={handleInputChange}
            // required
          />
          <CFormFeedback invalid>Enter Narration</CFormFeedback>
        </CCol>
      </Row>
      <Row className="row-xs mb-2 btn-animation">
        <CCol xs={12} className="mt-10">
          <CButton
            color="primary"
            className={`btn btn-sm float-end ${
              isSaveDisabled ? "btn-loaders" : ""
            }`}
            type="submit"
            disabled={isSaveDisabled}
          >
            {isSaveDisabled ? (
              <span className="loading">Save Changes</span>
            ) : (
              "Save Changes"
            )}
          </CButton>
          <CButton
            color="secondary"
            className="btn btn-sm float-end me-2"
            onClick={invisible}
            disabled={isSaveDisabled}
          >
            Close
          </CButton>
        </CCol>
      </Row>
    </FormWrapper>
  );
};

export default PaymentVchAddEdit;
